import authCheckApp from './authCheckApp'

/**
 * 显示安卓原生导航栏
 * @since 1.0.0
 * @example
 * 
 * showNavigation()
 */
function showNavigation() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('showNavigation', {}, (response) => {
                return response
            })
        })
}

export default showNavigation